import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import Header from "../components/studio/Header";
import Sidebar from "../components/studio/Sidebar";
import DisplayModeChoice from "../components/studio/DisplayModeChoice";
import { useAuth } from "./AuthContext";
import { displayModeKey, isFieldUser } from "../utils/access";

export default function AdminLayout() {
  const { user } = useAuth();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(() => localStorage.getItem("owsur-sidebar") !== "closed");
  const [isDesktop, setIsDesktop] = useState(() => window.matchMedia("(min-width: 981px)").matches);
  const [displayMode, setDisplayMode] = useState(() => localStorage.getItem(displayModeKey(user)) || "");
  const fieldUser = isFieldUser(user);

  useEffect(() => {
    const key = displayModeKey(user);
    setDisplayMode(localStorage.getItem(key) || "");
  }, [user]);

  useEffect(() => {
    const media = window.matchMedia("(min-width: 981px)");
    const listener = (event) => setIsDesktop(event.matches);
    setIsDesktop(media.matches);
    media.addEventListener("change", listener);
    return () => media.removeEventListener("change", listener);
  }, []);

  const chooseDisplayMode = (mode) => {
    localStorage.setItem(displayModeKey(user), mode);
    setDisplayMode(mode);
  };

  const toggleSidebar = () => {
    setSidebarOpen((current) => {
      const next = !current;
      localStorage.setItem("owsur-sidebar", next ? "open" : "closed");
      return next;
    });
  };

  if (fieldUser && isDesktop && !displayMode) {
    return <DisplayModeChoice user={user} onSelect={chooseDisplayMode} />;
  }

  const useMobileMode = fieldUser && (!isDesktop || displayMode === "mobile");
  if (useMobileMode && location.pathname !== "/mobile") {
    return <Navigate to="/mobile" replace />;
  }

  if (useMobileMode) {
    return (
      <div className="mobile-mode-root">
        <Outlet />
      </div>
    );
  }

  return (
    <div className={`app-container ${sidebarOpen ? "" : "is-sidebar-collapsed"}`}>
      <Header onToggleSidebar={toggleSidebar} sidebarOpen={sidebarOpen} />
      <div className="main-content">
        <Sidebar />
        <Outlet />
      </div>
    </div>
  );
}
